import { generateTypes } from '../../utils/HttpReducerHelper';

export const userById = generateTypes('LIST', 'BY_ID');
